<template>
  <div>
    <LcDescriptionList>
      <PriceListPerPlay v-bind="{ numberOfPlays: numberOfTickets }">
        {{
          $t('scratchcard.pricebreakdownlist.labels.scratchticket', {
            amount: prices.cardPrice,
          })
        }}
      </PriceListPerPlay>
      <dd>{{ formatMoney(prices.totalPrice) }}</dd>
    </LcDescriptionList>
  </div>
</template>

<script lang="ts" setup>
import Money from '~~/models/Money'

import { useScratchcardStore } from '../stores/scratchcard'

const { priceList } = useScratchcardGame()
const { currentPrice } = useScratchcardStore()
const numberOfTickets = computed(() => currentPrice(priceList.value)?.quantity ?? 1)
const totalPrice = computed(() => currentPrice(priceList.value)?.chargesForCards)

const prices = computed(() => ({
  cardPrice: new Money(totalPrice.value).dividedBy(numberOfTickets.value),
  totalPrice: new Money(totalPrice.value),
}))
</script>
